import { stoves as allStoves,benchShapes } from '../config.js'


var initialState =
{
    allStoves: allStoves.filter(s => s.id !== "ownStove"),
    selectableStoves: allStoves.filter(s => s.id !== "ownStove")
}



const stoves = (state = initialState, action) => {
    switch (action.type) {

        case 'BENCH_CHANGED':
            return Object.assign({}, state, {
                selectableStoves: filterStoves(action.bench.shape, state.allStoves)
            })
        case 'CLIENT_COFIGURATION_UPDATED':
            if (action.configuration.availableStoves) {
                let stoveIDsFromConfiguration = action.configuration.availableStoves.map(s => allStoves.filter(st => st.exportID === s.id)[0].id);
                return Object.assign({}, state, {
                    allStoves: filterStovesByIds(stoveIDsFromConfiguration, allStoves),
                    selectableStoves: filterStovesByIds(stoveIDsFromConfiguration, state.selectableStoves || allStoves)
                })
            }
            else {
                return state;
            }


       case 'PLAN_LOADED':
            {
                return Object.assign({}, state, {
                    selectableStoves: filterStoves(benchShapes.filter(s => s.code === action.plan.benchShape)[0], state.allStoves)
                })
            }

        default:
            return state;
    }
}

export default stoves
function filterStoves(shape, allStoves) {
    return allStoves.filter(s =>
        (!shape.stoveEmbedding || s.canBeEmbedded) &&
        (shape.stoveInCorner || !s.cornerStove));
}
function filterStovesByIds(ids, allStoves) {
    return allStoves.filter(s => ids.filter(id => id === s.id).length);

}
